var Log = /** @class */ (function () {
    function Log(props) {
        Object.assign(this, props);
        this.date = new Date(props.date);
    }
    return Log;
}());
export { Log };
export var Type;
(function (Type) {
    Type["App"] = "App";
    Type["Backoffice"] = "Backoffice";
    Type["Api"] = "Api";
})(Type || (Type = {}));
export var Action;
(function (Action) {
    Action["Cancel"] = "cancel";
    Action["Update"] = "update";
    Action["Disable"] = "disable";
    Action["Login"] = "login";
    Action["Logout"] = "logout";
})(Action || (Action = {}));
export var Entity;
(function (Entity) {
    Entity["Login"] = "login";
    Entity["Logout"] = "logout";
    Entity["CollaboratorTicket"] = "CollaboratorTicket";
    Entity["CollaboratorPacketTicket"] = "CollaboratorPacketTicket";
    Entity["Afiliate"] = "Afiliate";
    Entity["Article"] = "Article";
    Entity["BusinessUnit"] = "BusinessUnit";
    Entity["Collaborator"] = "Collaborator";
    Entity["Customer"] = "Customer";
    Entity["Device"] = "Device";
    Entity["DiscounReaason"] = "DiscounReaason";
    Entity["Family"] = "Family";
    Entity["Headboard"] = "Headboard";
    Entity["License"] = "License";
    Entity["OperationLine"] = "OperationLine";
    Entity["PacketTicket"] = "PacketTicket";
    Entity["ReceiptLayout"] = "ReceiptLayout";
    Entity["Stretch"] = "Stretch";
    Entity["Tax"] = "Tax";
    Entity["Ticket"] = "Ticket";
    Entity["User"] = "User";
    Entity["Voucher"] = "Voucher";
})(Entity || (Entity = {}));



//////////////////
// WEBPACK FOOTER
// ./src/modules/Logs/Model.ts
// module id = 331
// module chunks = 0